import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { initSentry } from '@/lib/monitoring/sentry';
import { initI18n } from '@/i18n';
import './styles/index.css';

initSentry();

async function bootstrap() {
  await initI18n('en_US');
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
